// extracted by mini-css-extract-plugin
export default {"wrapper":"Hover_wrapper__aDSt2","title":"Hover_title__JKwU2"};